// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-view[data-v-d32a902a] {
  padding-top: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.report-view .title[data-v-d32a902a] {
  color: #000;
  height: 40px;
  font-size: 18px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/DataAnalysis/ReportView.vue","webpack://./ReportView.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ACAF;ADNA;EAQI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;ACCJ","sourcesContent":["\n.report-view {\n  padding-top: 10px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  .title {\n    color: #000;\n    height: 40px;\n    font-size: 18px;\n    font-weight: 600;\n  }\n}\n",".report-view {\n  padding-top: 10px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.report-view .title {\n  color: #000;\n  height: 40px;\n  font-size: 18px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
